// TODO #851: remove this component when bug in volto-slate is fixed (related to Toolbar.jsx)
import React from 'react';

const Separator = () => {
  return <div className="toolbar-separator" />;
};

export default Separator;
